import { Controller } from '@hotwired/stimulus';
import Vue from 'vue';

// TODO: 分岐条件は暫定。リリース前に要リファクタ
function toggleItemOptions(select) {
  toggleActive(
    nextItemOptionsFields(select),
    !select.value.match(/text|picture|star|date/),
  );
  toggleActive(
    followingTextAreaOptions(select),
    Boolean(select.value.match(/text/)),
  );
}

function toggleActive(elements, active) {
  for (const el of elements) {
    el.classList.toggle('active', active);
  }
}

// jQuery の .next(selector) と同じく、直後の兄弟要素がセレクタに合うときだけ対象にする
function nextItemOptionsFields(select) {
  const next = select.closest('.p-formA__item').nextElementSibling;
  return next?.matches('.item_options_field') ? [next] : [];
}

function followingTextAreaOptions(select) {
  const fields = [];
  let el = select.closest('.p-formA__item').nextElementSibling;
  for (; el; el = el.nextElementSibling) {
    if (el.matches('.text_area_option')) fields.push(el);
  }
  return fields;
}

export default class extends Controller {
  static targets = ['template'];

  connect() {
    const el = this.templateTarget;

    this.vm = new Vue({
      el,
      data: {
        fields: [],
        // 静的ループ側 (質問を追加で増やしていない、既存/復元された質問) の件数。
        // mount 直後に実 DOM の件数から算出する (下記参照)。
        staticItemsCount: 0,
      },
      created: function () {
        this.toggle_incentive_options();
      },
      methods: {
        addInputField: function (e) {
          e.preventDefault();
          this.fields.push({ field: this.fields.length });
        },
        removeInputField: function (index) {
          if (this.staticItemsCount + this.fields.length <= 1) {
            alertify.error('質問は１つ以上必要です');
          } else {
            this.fields.splice(index, 1);
          }
        },
        toggle_item_options: (e) => {
          toggleItemOptions(e.target);
        },
        toggle_incentive_options: () => {
          const selected_value = document.querySelector(
            '#shop_campaign_incentive',
          )?.value;
          toggleActive(
            document.querySelectorAll('.shop_barcode_select'),
            selected_value === 'stamp',
          );
        },
        activ_destroy_flag_for_edit: (e) => {
          e.preventDefault();
          // NOTE: 削除ボタン内のアイコンをクリックした場合 e.target がアイコン
          // 要素になり data-item-id を取得できないため、リスナーがバインドされて
          // いるボタン自身を指す e.currentTarget を使う
          const shop_camapaign_item_id = e.currentTarget.dataset.itemId;
          // 削除フラグON
          for (const el of document.querySelectorAll(
            `.destroy_flag_${shop_camapaign_item_id}`,
          )) {
            el.value = '1';
          }
          e.currentTarget
            .closest('.p-formSections__item')
            .classList.remove('active');
        },
        // new 画面で、直前の送信内容から復元された質問(未保存)を取り除く
        // 保存済みレコードではないため destroy フラグは使わず、DOMから直接削除する
        remove_new_item: function (e) {
          if (this.staticItemsCount + this.fields.length <= 1) {
            alertify.error('質問は１つ以上必要です');
            return;
          }
          this.staticItemsCount -= 1;
          e.currentTarget.closest('.p-formSections__item').remove();
        },
      },
    });

    // 静的ループ側 (質問を追加で増やしていない件数) の初期値を実 DOM から算出する。
    // mount 直後は fields が空のため、この時点で .p-formSections__item に
    // 該当する要素は静的ループ側の質問のみ (質問を追加分は含まれない)
    this.vm.staticItemsCount = this.element.querySelectorAll(
      '.p-formSections__item',
    ).length;

    // 回答タイプ指定用セレクトボックスの表示を選択済みの値に合わせて初期化する
    // (new: 入力エラーで戻された質問, edit: 保存済みの質問, いずれも選択済みの値を持ちうる)
    for (const el of this.element.querySelectorAll('.item_types')) {
      toggleItemOptions(el);
    }
  }

  // メモリリーク防止のため、Vueインスタンスを破棄
  disconnect() {
    this.vm?.$destroy();
  }
}
